<template>
 <div>
   <!-- 面包屑导航 -->
  <div class="detailedbreadcrumb">
    <el-breadcrumb separator="/">
  <el-breadcrumb-item :to="{ path: '/Feedback' }">问题反馈</el-breadcrumb-item>
  <el-breadcrumb-item>问题详情</el-breadcrumb-item>
</el-breadcrumb>
  </div>

 <div>
  <div class="feedbackboady">
  <div class="detailedleft" style="">
    <div class="topdetailedleft" style="">{{detailedList.sourceType}}>{{detailedList.title}}</div>
  <hr>
    <!-- 左边边详情 -->
    <div style="display:inline-block;height:160px;">
      <div class="student">
      <div style="width:100px;height:100px;border:solid 1px #c5c5c5;border-radius: 50%; overflow:hidden;">
        <div style="width:100%;height:100%;border-radius: 50%;" v-if="detailedList.student">
        <img v-if="detailedList.student.headPic" :src="detailedList.student.headPic" alt="" style="width:100%;height:100%">
        </div>
      </div>
      <p style="text-align:center;" v-if="detailedList.student">{{detailedList.student.name}}</p>
      <p style="text-align:center;" v-else>无</p>
      <p style="text-align:center;" v-if="detailedList.student">{{detailedList.student.mobile}}</p>
      <p style="text-align:center;" v-else>无</p>
    </div>
    </div>
    <div style="display: inline-block; position: absolute; top: 63px; margin-bottom: 33px;">
      <p>{{detailedList.createTime}}</p>
      <p style="font-size:17px;word-break:break-all;word-wrap:break-word">{{detailedList.content}}</p>
      <div v-if="detailedList.picture !== ''">
        <div v-for="(item,index) in picture" :key="index" style="width:150px;height:190px; display:inline-block; margin:0 5px; border-radius: 8px; overflow: hidden;">
        <!-- <img v-if="detailedList.picture !== ''" :src="item" alt="" style="width:100%;height:100%"> -->
            <el-image 
            style="width:100%;height:100%"
            :src="item" 
            :preview-src-list="picture">
          </el-image>
        </div>
      </div>
    </div>
    <div class="answerbox" style="top:390px;left:0;" v-if="!detailedList.answer">
        <p style="font-size:18px;">问题回复:</p>
        <el-form :inline="true" :model="form" class="demo-form-inline">
     <el-form-item style="min-height: 140px;">
       <el-input type="textarea"  v-model="form.answer"></el-input>
       </el-form-item>
  </el-form>
  <el-button type="primary" style="position: absolute;top: 151px;right: 26px" @click="Submitanswer" v-auth="'/Feedback/Submit'">提交</el-button>
      </div>
      <div v-else class="answerbox" :style="{top:(detailedList.picture!=='' ?'368px':'150px')}" style="width: 600px; height: 240px; left: 128px; top:0;" >
        <p style="font-size:12px;">{{detailedList.answerTime}}</p>
        <span style="color:#645f5f">老师回复:</span>
        <span style="font-size:16px; word-wrap: break-word;">{{detailedList.answer}}</span>
        <i class="el-icon-delete-solid" style="position:absolute; top:0; right:0;cursor: pointer; font-size:16px;" @click="Submitdelete"></i>
      </div>
  </div>
  <!-- 中间间隙 -->
  <div style="width:20px; height:800px;"></div>
  <!-- 右边问题待回复 -->
<div class="detailedright">
<div  style="height: 49px;width: 387px; background-color: #fff;position: sticky;top: 0;">
  <div style="border-radius:8px; background-color:#645f5f; color:#fff;text-align:center;width:150px;height:20px;margin:15px;  position: absolute;" v-if="detailedList.feedBackList !== undefined && detailedList.feedBackList.length>0">待回复问题剩余:{{detailedList.feedBackList.length}}</div>
</div>
<div class="detailedrightson" v-for="(item,idx) in detailedList.feedBackList" :key="idx" @click="Locrouter(item.id)">
  <span>问题描述:{{item.title}}</span>
  <p style="overflow:hidden;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 3;;word-break:break-all;word-wrap:break-word">{{item.content}}</p>
</div>
</div>
 </div>

 </div>
 </div>
</template>
<script>
export default{
    name:'',
    data () {
        return {
          // 表单内容
            form:{
              idList:[],
              answer:''
            },
            // 返回数据
            detailedList:{},
        }
    },
    created () {
      // 进入页面调用详情信息
      this.getdetailedList()
    //  有idList就会把url地址添加至idList
     if(this.form.idList !== undefined){
    this.form.idList.push(this.$route.query.id)
     }
    },
    computed:{
    //将图片路径经逗号进行拆分成数组
    picture(){
      if(this.detailedList.picture !== undefined){
        return this.detailedList.picture.split(",")
      }
    
    }
    },
    methods:{
      // 右边待回复问题描述点击
      Locrouter(id){
      this.form.idList = []
      // console.log(this.$route);
      this.$route.query.id = id
      this.form.idList.push(this.$route.query.id)
      this.form.answer = ''
      this.getdetailedList()
      },
      //列表数据
      getdetailedList(){
        this.api.feedback.getfeedbackdetailed({id:this.$route.query.id}).then(res =>{
          
        this.detailedList = res.data
      })
      },
      // 提交表单内容
      Submitanswer(){
      this.api.feedback.feedbackAnswer(this.form).then(res =>{
        this.$message.success(res.message)
        this.getdetailedList()
      })
      },
      // 点击删除事件
      Submitdelete(){
        this.api.feedback.feedbackDelete({id:this.$route.query.id}).then(res =>{
        // console.log(res);
        this.getdetailedList()
        })
      }
      }
    }

</script>
<style lang='less'  scoped>
   .detailedbreadcrumb {
     width: 100%;
     height: 60px;
     background-color: #fff;
     border-radius: 5px;
     .el-breadcrumb{
       height: 100%;
       line-height: 60px;
       margin-left: 15px;
     }
   }
   .feedbackboady{
    display:flex;
    margin-top:15px;
    .detailedleft{
    position: relative;
    flex:1;
    height:800px;
    background-color:#fff; 
    padding-right:-20px; 
    border-radius: 10px;
    .topdetailedleft{
    margin:10px; 
    color:#5276ff; 
    font-weight: 600; 
    font-size: 14px;
    }
    .student{
      display: inline-block;
      // position: relative;
    //  top: -220px;
      margin:20px;
      width: 100px;
      height: 100px;
    }
    .answerbox{
      position:absolute;
      left: 128px;
      // bottom: 150px;
      margin-left:20px;
      /deep/.el-textarea{
        width: 665px;
       .el-textarea__inner{
      resize: none;
      height: 140px;
    }
      }
    
    }
        }
    .detailedright{
      width:400px; 
      height:800px; 
      background-color:#fff; 
      border-radius: 10px;
      overflow: scroll;
      .detailedrightson{
      width: 370px;
      height: 90px;
      margin:10px auto;
      background-color: #eeecec;
      color: rgb(100, 95, 95);
      border-radius: 9px;
      font-size: 12px;
      padding: 4px;
      cursor: pointer;
      }
    }
      }

</style>



// WEBPACK FOOTER //
// src/components/Feedback/Feedbackdetailed.vue